import { put, takeEvery, cancelled } from 'redux-saga/effects';
import { select, call } from 'typed-redux-saga';
import * as SearchActions from '../actions/search';
import * as selectors from '../selectors';
import { sendSearchResultsEvent } from './analytics';
import { searchArticles, SEARCH_PAGE_SIZE } from '../api/article';
import { getLanguageId } from '../utils/globals';

export function* requestSearch(
  action: ReturnType<typeof SearchActions.Actions.searchRequest>
) {
  const { query, page } = action.payload;
  const offset = (action.payload.page - 1) * SEARCH_PAGE_SIZE;

  const fetchingStatus = yield* select(
    selectors.searchFetchingStatus,
    query,
    page
  );

  const shouldFetch = fetchingStatus === 'not-started';
  if (!shouldFetch) return;

  try {
    yield put(SearchActions.Actions.searchFetchStarted({ query, page }));
    const languageId = yield* call(getLanguageId);
    const data = yield* call(searchArticles, query, languageId, offset);
    yield put(
      SearchActions.Actions.searchSuccess({ ...data, searchedTerm: query })
    );

    yield* call(sendSearchResultsEvent, query, page);
  } catch (error) {
    yield put(SearchActions.Actions.searchFail());
  } finally {
    if (yield cancelled()) {
      yield put(SearchActions.Actions.searchCancel());
    }
  }
}

// This watches for when we want to call the settings api and only allows the latest.
export function* watchSearchRequest() {
  yield takeEvery(SearchActions.ActionTypes.SEARCH_REQUEST, requestSearch);
}
